import { reportError } from '@this/lib/bugsnag';

/**
 * null許容で配列の最初の要素を取得する（Rubyのfirstメソッド相当）
 * @param array 対象の配列
 * @returns 最初の要素、または配列が空の場合はnull
 */
export function first<T>(array: T[]): T | null {
  const [element] = array;
  return element ?? null;
}

/**
 * 配列の最初の要素を安全に取得する
 * @param array 対象の配列
 * @param context デバッグ情報のためのコンテキスト
 * @returns 最初の要素、または配列が空の場合はundefined
 */
export function getFirstFromArray<T>(array: T[], context?: string): T | undefined {
  if (array.length === 0) {
    const error = new Error(`Attempted to get first element of empty array${context ? ` in ${context}` : ''}`);
    reportError(error);
    return undefined;
  }

  return array[0];
}

/**
 * 配列の最初の要素を取得し、存在しない場合はエラーを投げる
 * @param array 対象の配列
 * @param context デバッグ情報のためのコンテキスト
 * @returns 最初の要素
 * @throws 配列が空の場合
 */
export function getFirstFromArrayOrFail<T>(array: T[], context?: string): T {
  const item = getFirstFromArray(array, context);
  if (item === undefined) {
    throw new Error(`Required first element was not found${context ? ` in ${context}` : ''}`);
  }
  return item;
}
